import React from 'react'
import { useTranslation } from 'react-i18next'
import { H1, BillboardButton, Image, Paragraph, Row, Separator, Bleed, colors } from '@fs/zion-ui'
import { useHistory } from '@fs/zion-router'
import { trackEvent } from '@fs/zion-analytics'
import { PropTypes } from 'prop-types'
import { useDarkModeContext } from '../../providers/DarkModeProvider'

export default function SimpleTutorialPage({ slide, children, imageHeight, positionContentBottom = true }) {
  const history = useHistory()
  const { isDarkMode } = useDarkModeContext()
  const { t } = useTranslation()
  const spacerSize = positionContentBottom ? 'xl' : 'md'

  return (
    <div style={{ minHeight: '579px' }}>
      <Bleed all>
        <Image src={slide?.backgroundImage ?? ''} alt="" height={imageHeight || 'auto'} />
      </Bleed>
      <Separator />
      <Bleed sides bottom>
        <div
          style={{
            background: colors.gray00,
            borderStartStartRadius: '20px',
            borderStartEndRadius: '20px',
            ...(positionContentBottom ? { position: 'absolute', bottom: '0' } : {}),
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '-300px',
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Image maxHeight="320px" noCrop alt="" src={slide?.foregroundImage ?? ''} />
          </div>
          <Separator size={spacerSize} />
          <div style={{ paddingInlineStart: '20px', paddingInlineEnd: '20px' }}>
            <Row alignX="center">
              {slide.icon && (
                <Image
                  src={slide.icon ?? ''}
                  alt={slide?.title}
                  maxHeight="40"
                  maxWidth="40"
                  style={isDarkMode ? { filter: 'invert(1)' } : null}
                />
              )}
              <H1 size="H4" centered>
                {slide?.title}
              </H1>
            </Row>
            <Separator />
            <Paragraph size="sm" centered>
              {slide?.description}
            </Paragraph>
            <Separator size="lg" />
            {!children && (
              <Row alignX="center">
                <BillboardButton
                  emphasis="high"
                  color="gray"
                  onClick={() => {
                    const nextPath = typeof slide.next === 'function' ? slide.next() : slide.next
                    history.push(nextPath)
                    trackEvent({ event_name: 'tutorial:NEXT:CLICK' })
                  }}
                >
                  {t('common-ui:next.action', 'Next*')}
                </BillboardButton>
              </Row>
            )}
            {children && <>{children}</>}
            <Separator size="lg" />
          </div>
        </div>
      </Bleed>
    </div>
  )
}

// proptypes
SimpleTutorialPage.propTypes = {
  slide: PropTypes.shape({
    backgroundImage: PropTypes.string,
    foregroundImage: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    next: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  }),
  imageHeight: PropTypes.string,
  positionContentBottom: PropTypes.bool,
  children: PropTypes.node,
}
